/** Dispatched after a payment is updated outside list hooks (e.g. quota mark-as-paid). */
export const PAYMENT_UPDATED_EVENT = 'leadsme:payment-updated';
